import { IrArticleTextMessage } from './IrArticleTextMessage';

export default IrArticleTextMessage;
